module.exports = __webpack_public_path__ + "assets/img/step3-title.b7b14f2f.svg";